import React from "react";
import { Route } from "react-router-dom";
import SupportPage from "pages/PowerUser/Support/Support.page";
import PowerUsersPage from "pages/PowerUser/PowerUsers/power-users.page";
import OrganizationsPage from "pages/PowerUser/Organizations/organizations.page";
import AdminsPage from "pages/PowerUser/Admins/administration.page";
import InventoryPage from "pages/PowerUser/inventory/inventory.page";
import SoftwareAutoPage from "pages/PowerUser/software/auto/software-auto.page";
import PrivateRoute from "./components/PrivateRoute";
import SoftwareManualPage from "pages/PowerUser/software/manual/software-manual.page";
import DemoUsersPage from "pages/demo-users/demo-users.page";
import DeviceLookupPage from "pages/device-lookup/device-lookup.page";
import VersionsPage from "pages/PowerUser/software/version/versions.page";
import ManageVersionsPage from "pages/PowerUser/software/manage/manage-versions.page";

const PowerUserRoute = () => (
  <>
    <Route
      path="/orgs"
      element={
        <PrivateRoute>
          <OrganizationsPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/admins"
      element={
        <PrivateRoute>
          <AdminsPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/power-users"
      element={
        <PrivateRoute>
          <PowerUsersPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/support"
      element={
        <PrivateRoute>
          <SupportPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/inventory"
      element={
        <PrivateRoute>
          <InventoryPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/software-auto"
      element={
        <PrivateRoute>
          <SoftwareAutoPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/software-manual"
      element={
        <PrivateRoute>
          <SoftwareManualPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/demo-users"
      element={
        <PrivateRoute>
          <DemoUsersPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/device-lookup"
      element={
        <PrivateRoute>
          <DeviceLookupPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/versions"
      element={
        <PrivateRoute>
          <VersionsPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/manage-versions"
      element={
        <PrivateRoute>
          <ManageVersionsPage />
        </PrivateRoute>
      }
    />
  </>
);

export default PowerUserRoute;
